import { z } from 'zod';

import { OtherExplanationSchema } from '@Containers/OtherExplanations/validators';
import { MarketingIndustrySchema } from '../MarketPolicies/validators';
import { ProductInformationSchema } from '../ProductInformation/validate';
import { CombinedCorporateInformationSchema } from '../GeneralInfomation/validators';
import {
  EMPTY_FIELD_MESSAGE,
  validateEditorEn,
  validateSpace,
  validateSpaceTextInput,
  validateTextEn,
} from '@Utils/validation';
import { IncomeStructureSchema } from '../IncomeStructure/validators';

enum REMARK_MESSAGE {
  DESCRIPTION_EN = 'กรุณาระบุหมายเหตุเป็นภาษาอังกฤษ',
}

enum INTRO_MESSAGE {
  DESCRIPTION_EN = 'กรุณาระบุคำบรรยายเป็นภาษาอังกฤษ',
}

const IntroductionFormSchema = z.object({
  descriptionTh: z
    .string()
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .nullable()
    .optional(),
  descriptionEn: z
    .string()
    .regex(validateEditorEn, { message: INTRO_MESSAGE.DESCRIPTION_EN })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .nullable()
    .optional(),
});

const RemarkFormSchema = z.object({
  descriptionTh: z
    .string()
    .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .nullable()
    .optional(),
  descriptionEn: z
    .string()
    .regex(validateTextEn, { message: REMARK_MESSAGE.DESCRIPTION_EN })
    .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .nullable()
    .optional(),
});

export const NatureOfBusinessSchema = z.object({
  introduction: IntroductionFormSchema.optional(),
  corporateInformation: CombinedCorporateInformationSchema,
  marketingIndustry: MarketingIndustrySchema,
  productInformation: ProductInformationSchema,
  incomeStructure: IncomeStructureSchema,
  otherDescriptions: z.array(OtherExplanationSchema).optional(),
  remark: RemarkFormSchema.optional(),
});
